var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationNoData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 121,
    viewBox: "0 0 140 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "40.206%",
    y2: "90.903%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E9ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: ".596%",
    x2: "100%",
    y1: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: ".596%",
    x2: "100%",
    y1: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: ".596%",
    x2: "100%",
    y1: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M6,0 L134,0 C137.313708,0 140,2.6862915 140,6 L140,115 C140,118.313708 137.313708,121 134,121 L6,121 C2.6862915,121 0,118.313708 0,115 L0,6 C0,2.6862915 2.6862915,0 6,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3,0 L119,0 C120.656854,0 122,1.3431458 122,3 L122,12 C122,13.6568542 120.656854,15 119,15 L3,15 C1.3431458,15 0,13.6568542 0,12 L0,3 C0,1.3431458 1.3431458,0 3,0 Z",
    transform: "translate(9 8)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 78,
    fill: "#FFF",
    rx: 3,
    transform: "translate(9 26)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 3,
    x: 15,
    y: 31,
    fill: "url(#b)",
    fillRule: "nonzero",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 3,
    x: 15,
    y: 43,
    fill: "url(#b)",
    fillRule: "nonzero",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 3,
    x: 15,
    y: 37,
    fill: "url(#b)",
    fillRule: "nonzero",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "nonzero",
    d: "M19,49 L120,49 C122.209139,49 124,50.790861 124,53 L124,74 C124,76.209139 122.209139,78 120,78 L19,78 C16.790861,78 15,76.209139 15,74 L15,53 C15,50.790861 16.790861,49 19,49 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "nonzero",
    d: "M28.5,14 L88.5,14 C89.3284271,14 90,14.6715729 90,15.5 C90,16.3284271 89.3284271,17 88.5,17 L28.5,17 C27.6715729,17 27,16.3284271 27,15.5 C27,14.6715729 27.6715729,14 28.5,14 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E8FF",
    fillRule: "nonzero",
    d: "M17.7683799,12.3129856 L19.8202237,12.3140709 C20.9239671,12.3146546 21.8185821,13.2092696 21.8191658,14.313013 L21.8202512,16.3648569 C21.820835,17.4694262 20.9258781,18.3653301 19.8213088,18.3659145 C19.8206037,18.3659145 19.8198986,18.3659145 19.8191935,18.3659145 L17.7673496,18.3648292 C16.6636063,18.3642455 15.7689912,17.4696304 15.7684076,16.3658871 L15.7673222,14.3140432 C15.7667384,13.2094739 16.6616952,12.31357 17.7662646,12.3129856 C17.7669697,12.3129856 17.7676748,12.3129856 17.7683799,12.3129856 Z",
    transform: "rotate(45 18.794 15.34)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationNoData);
export default __webpack_public_path__ + "static/media/illustration-no-data.bea6ab737548920a37f5947fe38afed9.svg";
export { ForwardRef as ReactComponent };